<template>
  <Layout>
    <div>
      <h1>Workshop Registration</h1>
      
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h3>The Asian and Oceania Workshop on Data, Inference and Security </h3>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleRegistration">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="firstName">First Name *</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="firstName" 
                        v-model="form.firstName"
                        required
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="lastName">Last Name *</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="lastName" 
                        v-model="form.lastName"
                        required
                      >
                    </div>
                  </div>
                </div>
                
                <div class="form-group">
                  <label for="email">Email *</label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email" 
                    v-model="form.email"
                    required
                  >
                </div>
                
                <div class="form-group">
                  <label for="organization">Organization *</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="organization" 
                    v-model="form.organization"
                    required
                  >
                </div>
                
                <div class="form-group">
                  <label for="country">Country *</label>
                  <CountrySelect 
                    v-model="form.country"
                  />
                </div>
                
                <!-- 获取会议列表 -->
                <div class="form-group">
                  <label for="session">Session *</label>
                  <select class="form-control" id="session" v-model="form.session_id" required>
                    <option value="">Select Session</option>
                    <option v-for="session in sessionList" :key="session.id" :value="session.id">
                      {{ session.title }}
                    </option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label for="registrationType">Registration Type *</label>
                  <select class="form-control" id="registrationType" v-model="form.registrationType" required>
                    <option value="">{{ loadingTickets ? 'Loading tickets...' : 'Select Registration Type' }}</option>
                    <option v-if="ticketList && ticketList.id" :value="ticketList.type">
                      {{ ticketList.type }} - {{ ticketList.currency }} {{ ticketList.fee }}
                    </option>
                  </select>
                  <small v-if="loadingTickets" class="form-text text-muted">
                    Loading available registration types...
                  </small>
                </div>
                
                <div class="form-group">
                  <label for="dietary">Dietary Requirements</label>
                  <select class="form-control" id="dietary" v-model="form.dietary">
                    <option value="">No Special Requirements</option>
                    <option value="vegetarian">Vegetarian</option>
                    <option value="vegan">Vegan</option>
                    <option value="halal">Halal</option>
                    <option value="kosher">Kosher</option>
                    <option value="gluten-free">Gluten Free</option>
                  </select>
                </div>
                
                <div class="form-group">
                  <label for="specialNeeds">Special Needs</label>
                  <textarea 
                    class="form-control" 
                    id="specialNeeds" 
                    rows="3"
                    v-model="form.specialNeeds"
                    placeholder="Please specify any special needs or requirements..."
                  ></textarea>
                </div>
                
                <div class="form-group">
                  <button type="submit" class="btn btn-primary btn-lg" :disabled="loading">
                    {{ loading ? 'Processing...' : 'Register Now' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h4>Registration Information</h4>
            </div>
            <div class="card-body">
              <!-- <h5>Registration Fees</h5>
              <ul class="list-unstyled">
                <li><strong>Regular:</strong> $300</li>
              </ul>
              
              <hr> -->
              
              <h5>Workshop Dates</h5>
              <ul class="list-unstyled">
                <li><strong></strong>14 - 16 Nov, 2025</li>
              </ul>
              
              <hr>
              
              <h5>Location:</h5>
              <ul class="list-unstyled">
                <li>  Penang, Malaysia</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import CountrySelect from '@/components/CountrySelect.vue'
import { apiService } from '@/config/api'

export default {
  name: 'Registration',
  components: {
    Layout,
    CountrySelect
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        organization: '',
        country: '',
        registrationType: '',
        dietary: '',
        specialNeeds: '',
        session_id: ''
      },
      sessionList: [],
      ticketList: null, // 票价对象
      loading: false,
      loadingTickets: false // 加载票价状态
    }
  },
  mounted() {
    this.getRegistration()
    this.loadUserProfile()
  },
  
  watch: {
    'form.session_id'(newVal) {
      // 清空之前选择的注册类型
      this.form.registrationType = ''
      // 获取新的票价列表
      this.getTicketList(newVal)
    }
  },

  methods: {
    // 获取用户信息并回显到表单
    async loadUserProfile() {
      try {
        const response = await apiService.auth.getProfile()
        if (response.data && response.data.data) {
          const userData = response.data.data
          // 将用户信息回显到表单
          this.form.firstName = userData.first_name || ''
          this.form.lastName = userData.last_name || ''
          this.form.email = userData.email || ''
          this.form.organization = userData.organization || ''
          this.form.country = userData.country || ''
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 如果获取失败（如未登录），静默忽略，允许用户手动填写
      }
    },
    // 获取注册信息
    async getRegistration() {
      // 获取正在进行的会议列表
      const response = await apiService.sessions.getActiveList({status: 1})
      this.sessionList = response.data.data.list
    },
    // 获取票价列表
    async getTicketList(sessionId) {
      if (!sessionId) {
        this.ticketList = null
        return
      }
      this.loadingTickets = true
      try {
        const response = await apiService.sessions.getTicketList({ session_id: sessionId })
        
        if (response.data && response.data.code === 1) {
          this.ticketList = response.data.data.ticket || null
        } else {
          this.ticketList = null
        }
      } catch (error) {
        console.error('获取票价列表出错:', error)
        this.ticketList = null
      } finally {
        this.loadingTickets = false
      }
    },
    async handleRegistration() {
      this.loading = true
      try {
        // 1. 注册会议
        const registerRes = await apiService.sessions.register(this.form)
        if(registerRes.data.code == 1) {
          const registrationId = registerRes?.data?.data?.data.registrationId
          
          // 2. 创建注册支付账单订单号
          const billRes = await apiService.sessions.createRegistrationBill({
            registration_id: registrationId,
            type: "ticket"
          })
          console.log('创建账单响应:', billRes.data)
          
          // 从响应中获取 order_no
          const order_no = billRes?.data?.data?.order_no || billRes?.data?.data?.data?.order_no
          
          if (order_no) {
            // 3. 调用支付接口
            const payRes = await apiService.sessions.doPay({
              order_no: order_no
            })
            console.log('支付响应:', payRes.data)
            
            if (payRes.data && payRes.data.code === 1) {
              alert('Registration and payment successful!')
            } else {
              alert(payRes.data?.msg || 'Payment failed')
            }
          } else {
            console.error('未获取到 order_no')
            alert('Failed to create payment order')
          }
        } else {
          alert(registerRes.data.data.message || 'Registration failed')
        }
      } catch (error) {
        console.error('Registration error:', error)
        alert('Registration failed, please try again')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.form-group {
  margin-bottom: 1rem;
}

.btn-lg {
  padding: 12px 30px;
  font-size: 18px;
}

.list-unstyled li {
  margin-bottom: 8px;
}
</style> 